<template>
  <!-- eslint-disable vue/no-v-html -->
  <transition
    name="fade-slide-right"
    mode="out-in"
    appear
  >
    <section>
      <h3 v-html="$currentCollection.claim" />
      <p v-html="$themedContent.claim" />
    </section>
  </transition>
</template>
<script>
export default {
  name: 'HomeContent',
};
</script>
<style lang="stylus" scoped>
section {
  width: 310px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  padding: 8px 0 0 8px;

  +below($bp-xl) {
    width: 260px;
  }

  +mobile() {
    width: 100%;
    padding: 0;
  }

  h3 {
    font-size: 36px;
    text-transform: uppercase;
    line-height: 1.1;
    display: flex;
    flex-direction: column;
    b, strong, em {
      display: block;
    }
  }
  p {
    font-size: 14px;
    line-height: 1.4;
  }
}
</style>
